const GATOR_BACKUP_PLANS = {
  CORE: 'gator_backup_core',
  PLUS: 'gator_backup_plus',
  ADVANCED: 'gator_backup_advanced',
  MAX: 'gator_backup_max',
};

const GATOR_BACKUP_TYPE = {
  BR: 'gatorbackup',
  ES: 'gatorbackupes',
};

const GATOR_BACKUP_PLANS_IDS = {
  BR: {
    CORE: 569,
    PLUS: 572,
    ADVANCED: 575,
    MAX: 578,
  },
  ES: {
    CORE: 344,
    PLUS: 347,
    ADVANCED: 350,
    MAX: 353,
  },
};

const HIGHLIGHT_ID = {
  BACKUP_AUTO: 1,
  BACKUP_CLOUD: 2,
  BACKUP_ALERT: 3,
};

const PLAN_CYCLE_TYPES = {
  ANNUALLY: 'annually',
  SEMIANNUALLY: 'semiannually',
  QUARTERLY: 'quarterly',
  MONTHLY: 'monthly',
};

export {
  GATOR_BACKUP_PLANS, GATOR_BACKUP_PLANS_IDS, HIGHLIGHT_ID, PLAN_CYCLE_TYPES, GATOR_BACKUP_TYPE,
};
